<template lang="pug">
  .content
    draggable(v-model="sortedList" @start="drag = true" @end="drag = false" v-bind="dragOptions")
      transition-group(type="transition" :name="!drag ? 'flip-list' : null")
        el-card.program-card(v-for="program in list" :key="program.id")
          icon.icon(name="bars")
          | {{program.title}}
</template>

<script>
import Draggable from "vuedraggable";

export default {
  components: {
    Draggable
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  computed: {
    sortedList: {
      get() {
        return this.list;
      },
      set(value) {
        this.$emit("update:list", value);
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  data() {
    return {
      drag: false
    };
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.content {
  max-height: 500px;
  overflow-y: scroll;
}

.program-card {
  margin-bottom: 10px;
  cursor: move;

  .icon {
    margin-right: 10px;
  }

  :global(.el-card__body) {
    padding: 10px;
    display: flex;
    align-items: center;
  }
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
